import { Box, Typography, useTheme } from "@mui/material";
import { Trans } from "react-i18next";
import type { CurrencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	getResourcePath,
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { moneyFormatter } from "web_myplann/Shared/Utils/formatters";
import type { DashboardType } from "./DashboardTitleCard";

type DashboardCardValueProps = {
	dashboardData: DashboardType;
	isMissingValueWithItems: boolean;
	isDashboardDetail?: boolean;
};

export const DashboardCardValue = ({
	dashboardData,
	isMissingValueWithItems,
	isDashboardDetail,
}: DashboardCardValueProps) => {
	const { t } = useResource();
	const { palette } = useTheme();

	if (isMissingValueWithItems) {
		const top = isDashboardDetail ? "80px" : "92px";

		return (
			<Typography
				component="div"
				fontSize={14}
				fontWeight={400}
				lineHeight="20px"
				textAlign="center"
				color={palette.darkmodeText.white}
				position="absolute"
				top={top}
				px={4}
				zIndex={1}
			>
				<Trans
					i18nKey={getResourcePath(Resources.Dashboard.TitleCard.zeroValue)}
					count={dashboardData.itemCountWithoutValue}
					components={{
						b: <Box component="span" sx={{ fontWeight: 700 }} />,
					}}
				/>
			</Typography>
		);
	}

	const currencyLabel = t(
		Resources.PortfolioDetail.SharedLabels.Currency[
			dashboardData.currency as CurrencyEnum
		],
	);

	return (
		<Typography
			fontSize={32}
			fontWeight={700}
			color={palette.darkmodeText.white}
			position="absolute"
			top={isDashboardDetail ? "80px" : "86px"}
			zIndex={1}
		>
			{moneyFormatter(Math.round(dashboardData.value ?? 0), currencyLabel)}
		</Typography>
	);
};
